import React from "react";
import { Tag } from "@app/shared/src/components_v2";
import { describeMediaRequestStatus, MediaRequestStatusInput } from "../../helpers/mediaRequestStatus";

/**
 * A media request's lifecycle at a glance, worded the way the dashboard words it. Colour carries
 * the triage (amber = the unit is on it, green = watchable, red = it failed); the label carries
 * the stage, and the upload stage carries its percentage and rate.
 */
export const MediaRequestStatusTag: React.FC<{ request: MediaRequestStatusInput }> = ({ request }) => {
    const { label, tone } = describeMediaRequestStatus(request);
    return <Tag tone={tone}>{label}</Tag>;
};
